import { useUserData } from "src/context/userContext";
import PropTypes from "prop-types";
import PersonSelectorDropDown from "../person/PersonList/PersonSelectorDropDown";
import { vehicle_setDefaultPumppari } from "./VehicleFunctions";
import ProgressBar from "../layout/Progress/ProgressBar";
import { useState } from "react";

export default function EditVehicle_DefaultKuski_Dropdown({ vehicle, setVehicle }) {
  const { ownerAsiakasId, token, socket } = useUserData();
  const [isLoading, setIsLoading] = useState(false);

  if (!vehicle) return null;
  if (!ownerAsiakasId) return null;

  const handleInputChange = async (person) => {
    setIsLoading(true);
    vehicle.defaultKuski_personId = person?.personId;
    setVehicle(vehicle);
    await vehicle_setDefaultPumppari(vehicle.vehicleId, person?.personId, token, socket);
    setIsLoading(false);
  };

  return (
    <div>
      <PersonSelectorDropDown
        asiakasId={ownerAsiakasId}
        asiakasPersonSettingTypeId={8} // 8 = isPumppari
        variant="outlined"
        label="Oletus pumppari"
        setPerson={handleInputChange}
        showEmail={false}
        showPhone={false}
        allowNull={true}
        defaultPersonId={vehicle.defaultKuski_personId}
      />
      <ProgressBar show={isLoading} />
    </div>
  );
}

EditVehicle_DefaultKuski_Dropdown.propTypes = {
  vehicle: PropTypes.object.isRequired,
  setVehicle: PropTypes.func.isRequired,
};
